// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"OpacityTrigger__parentContainer___1tAA-","childContainer":"OpacityTrigger__childContainer___3dRmT"};